import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Modal from "src/components/Modal"

import { closeWorkOrder } from "src/api/Service/WorkOrders"

import useWorkOrderActionMutation from "./hooks/use_work_order_action_mutation"

const CloseWorkOrderModal = ({
  isOpen,
  onClose,
  workOrder,
  workOrderSequentialId,
}) => {
  const { mutate, isLoading, handleCancel } = useWorkOrderActionMutation({
    workOrderSequentialId,
    action: closeWorkOrder,
    eventPrefix: "work_orders:close_work_order",
    successMessage: "Work order closed.",
    errorMessage: "Failed to close work order.",
    onClose,
  })

  const customerName = workOrder.contact?.name || workOrder.contact?.email
  const boatName = workOrder.contactBoat?.name

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="default">
      <Modal.Header title="Close Work Order" />
      <Modal.Body>
        <p className="mb-3 text-sm font-semibold text-gray-900">
          {`#${workOrder.displaySequentialId}`}
          {customerName ? ` · ${customerName}` : ""}
          {boatName ? ` · ${boatName}` : ""}
        </p>
        <p className="mb-0 text-sm text-gray-600">
          Closing locks the work order from new jobs and edits. You can reopen
          it at any time to make changes.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end gap-2">
          <Button
            variant="secondary"
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={() => mutate()}
            isLoading={isLoading}
          >
            Close Work Order
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

CloseWorkOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  workOrder: PropTypes.shape({
    displaySequentialId: PropTypes.string,
    contact: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
    contactBoat: PropTypes.shape({ name: PropTypes.string }),
  }).isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default CloseWorkOrderModal
